import Api from "../index";
import {AtriaApi, BackendApi} from "../Internal";

let token = '';

export function getToken(): string {
    return token;
}

export function setToken(newToken: string) {
    token = newToken;
}

let serverCode = '';

export function getServerCode() {
    return serverCode;
}

export function setServerCode(newServerCode: string) {
    serverCode = newServerCode;
}

let proxy = '';

export function getProxy() {
    return proxy;
}

export function setProxy(newProxy: string) {
    proxy = newProxy;
}

let login = '';

export function getLogin() {
    return login;
}

export function setLogin(newLogin: string) {
    login = newLogin;
}

let next = '';

export function getNext() {
    return next;
}

export function setNext(newNext: string) {
    next = newNext;
}

export const appRoot = window?.DYDU_TARGETS?.app_root;

const ATRIA_SERVLET_PATH = '/servlet';

export const getAtriaPath = () => {
    let url = `https://${serverCode}${ATRIA_SERVLET_PATH}`;

    if (proxy) {
        url = `${proxy}${ATRIA_SERVLET_PATH}`;
    }

    return url;
};

export const getGatewayUrl = () => {
    if (proxy) {
        return proxy;
    }
    return window?.DYDU_TARGETS?.gateway_url;
};

export function getAtriaApi(): AtriaApi {
    const headers = {};
    return Api.getAtriaInstance(getAtriaPath(), getToken(), headers);
}

export function getBackendApi(): BackendApi {
    const headers = {};
    return Api.getBackendInstance(getGatewayUrl(), getToken(), headers);
}